import { Box, MultiSelect, Text, SimpleGrid } from "@mantine/core";

interface GeographyMarketsProps {
  formData: {
    operatingCountries: string[];
    preferredRegions: string[];
  };
  updateForm: (field: string, value: any) => void;
  countryOptions:
    | { group: string; items: { value: string; label: string }[] }[]
    | { group: string; items: string[] }[]
    | string[];
  regionOptions: { value: string; label: string }[];
}

export default function GeographyMarkets({
  formData,
  updateForm,
  countryOptions,
  regionOptions,
}: GeographyMarketsProps) {
  // Keep both fields on the same option source as requested.
  // `countryOptions` remains in props for backward compatibility with parent usage.
  void countryOptions;

  return (
    <Box>
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
        {/* Operating GEOGRAPHIES - Always editable */}
        <MultiSelect
          label={
            <Text fz="sm" fw={500}>
              Operating GEOGRAPHIES{" "}
              <Text span c="red" fz="lg">
                *
              </Text>
            </Text>
          }
          placeholder="Select regions"
          data={regionOptions}
          value={formData.operatingCountries}
          onChange={(value) => updateForm("operatingCountries", value)}
          searchable
        />

        {/* Preferred Regions - Always editable */}
        <MultiSelect
          label={
            <Text fz="sm" fw={500}>
              Preferred Collaboration Regions (Optional)
            </Text>
          }
          placeholder="Select regions"
          data={regionOptions}
          value={formData.preferredRegions}
          onChange={(value) => updateForm("preferredRegions", value)}
          searchable
        />
      </SimpleGrid>
    </Box>
  );
}
